<template>
  <div class="sion-login-container">
    <div class="sion-login-signin">
      <cube-form>
        <cube-form-group>
          <div class="sign-box">
            <div class="sign-label">
              <label for>
                <span>密码</span>
              </label>
            </div>
            <div class="sign-input">
              <el-input
                class="password-input"
                v-model="siginInfo.password"
                :type="passwordType"
                :onkeyup="passwordCheck('password')"
                placeholder="请输入您的密码"
                minlength="6"
                maxlength="16"
              >
                <i slot="suffix" class="el-icon-view" :style="{color:passwordType==''?'#38c7c4':''}" @click="togglePwd('passwordType')"></i>
              </el-input>
            </div>
          </div>
        </cube-form-group>
        <cube-form-group>
          <div class="sign-box">
            <div class="sign-label">
              <label for>
                <span>确认密码</span>
              </label>
            </div>
            <div class="sign-input">
              <el-input
                class="password-input"
                v-model="siginInfo.passwordAgain"
                :type="passwordAgainType"
                :onkeyup="passwordCheck('passwordAgain')"
                placeholder="请确认您的密码"
                minlength="6"
                maxlength="16"
              >
                <i slot="suffix" class="el-icon-view passwordAgain" :style="{color:passwordAgainType==''?'#38c7c4':''}" @click="togglePwd('passwordAgainType')"></i>
              </el-input>
            </div>
          </div>
        </cube-form-group>
      </cube-form>
    </div>
    <cube-form-group>
      <cube-button :disabled="siginInfo.disabled" @click="complete">设置密码</cube-button>
      <div class="sion-btn" @click="out">取消</div>
    </cube-form-group>
  </div>
</template>
<script type="text/ecmascript-6">
import {toast} from '@/common/api/api.js';
import {updatePassword} from '@/common/api';
export default {
  data() {
    return {
      password:"password",
      passwordAgain:"password",
      siginInfo: {
        password: "",
        passwordAgain: "",
        disabled:true
      },
      passwordType:'password',
      passwordAgainType:'password'
    };
  },
  watch: {
    siginInfo:{
      deep:true,
      handler:(value)=>{
        if((value.password == value.passwordAgain) && value.password != ""){
          value.disabled = false;
        }else{
          value.disabled = true;
        }
      }
    }
  },
  methods: { 
    togglePwd(str){
      this[str] === 'password' ? this[str] = '' : this[str] = 'password';
    },

    passwordCheck(str){
      if(this.siginInfo[str].indexOf(" ")!=-1){
         this.siginInfo[str] =this.siginInfo[str].replace(/\s+/g,'');
         toast(this,'不能输入空格','error');
      }
    },


    complete() {
      if(this.siginInfo.password !== this.siginInfo.passwordAgain){
        toast(this,'两次密码不一致','error');
        return
      }
      if(this.siginInfo.password.length < 6){
        toast(this,'密码长度在6到16位字符','error');
        return
      }
      updatePassword({
        passWord:this.siginInfo.password
      }).then(res=>{
        if(res.code == 200){
          toast(this,res.message,'');
          setTimeout(() => {
            this.$router.go(-1)
          }, 1500);
        }else{
          toast(this,res.message,'error');
        }
      });
      
    },
    out() {
        this.$router.go(-1)
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus">
@import '../../assets/stylus/index.styl';
.password-input{
  input{
    border:none;
  }
  .el-input__suffix-inner {
    pointer-events: all;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>